<template>
    <div class="col-md-12">
        <div class="ln_solid"></div>
        <br />
        <form @submit.prevent="searchData()" role="form">
            <div class="row">
                <div class="col-2">

                    <input type="text"
                           class="form-control"
                           v-model="pagingInfo.search"
                           placeholder="First Name..." />

                </div>

                <div class="col-2">

                    <input type="text"
                           class="form-control"
                           v-model="pagingInfo.mname"
                           placeholder="Middle Name..." />

                </div>

                <div class="col-2">

                    <input type="text"
                           class="form-control"
                           v-model="pagingInfo.lname"
                           placeholder="Last Name..." />

                </div>

                <div class="col-2">

                    <input type="text"
                           class="form-control"
                           v-model="pagingInfo.alias"
                           placeholder="Alias..." />

                </div>

                <div class="col-2">

                    <select id="region"
                            class="form-control"
                            v-model="pagingInfo.mydata">
                        <option value="0">All Data</option>
                        <option value="1">My Encodes</option>
                    </select>

                </div>
                <div class="col-2">

                    <button type="submit" class="btn btn-info ">
                        <strong>Search</strong>
                    </button>&nbsp;
                    <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>

                </div>
            </div>
        </form>
        <br />

        <div class="box">
            <div class="box-header"></div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                <a>First Name</a>
                            </th>
                            <th>
                                <a>Last Name</a>
                            </th>
                            <th>
                                <a>Middle Name</a>
                            </th>
                            <th>
                                <a>Alias</a>
                            </th>
                            <th>Suffix</th>
                            <th>Comments</th>
                            <th>Birth Date</th>
                            <th>Nationality</th>
                            <th>Created By</th>
                            <th>
                                <a>Date Created</a>
                            </th>
                            <th>Updated By</th>
                            <th>
                                <a>Date Updated</a>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, index) in persons" :key="user.id">
                            <td>{{ user.firstName | capitalize }}</td>
                            <td>{{ user.lastName | capitalize }}</td>
                            <td>{{ user.middleName | capitalize }}</td>
                            <td>{{ user.alias | capitalize }}</td>
                            <td>{{ user.nameSuffix | capitalize }}</td>
                            <td>{{ user.comments | capitalize }}</td>
                            <td>{{ user.birthDate | formatDate }}</td>
                            <td>{{ user.nationality }}</td>
                            <td>{{ user.createdBy }}</td>
                            <td>{{ user.dateCreated | formatDate }}</td>
                            <td>{{ user.updatedBy }}</td>
                            <td>{{ user.dateUpdated | formatDate }}</td>
                            <td v-if="$store.getters.LINKMODE">
                                <button class="btn btn-sm btn-success"
                                        @click="setLink(user.id)">
                                    Link Object
                                </button>
                            </td>
                            <td v-else-if="$store.getters.CRAD">
                                <TheDropDownButton>
                                    <btn @click.native="deletePerson(user.id, user.pid,index)"
                                         icon="fa fa-trash"
                                         title="Delete"></btn>
                                    <btn @click.native="editPerson(user.pid)"
                                         icon="fa fa-pencil-alt"
                                         title="Edit"></btn>
                                    <btn @click.native="viewLogs(user.id)"
                                         icon="fa fa-cogs"
                                         title="View Profile Download Logs"></btn>
                                    <btn @click.native="addtoMerge(user)"
                                         icon="fa fa-code-branch"
                                         title="Merge Record"></btn>
                                    <btn @click.native="requestlinkdownload(user.id)"
                                         icon="fa fa-cloud-download-alt"
                                         title="Export"></btn>
                                    <btn @click.native="attachSOI(user.id)"
                                         icon="fa fa-upload"
                                         title="Profile/SOI Upload"></btn>
                                    <btn @click.native="soidb(user.id)"
                                         icon="fa fa-file"
                                         title="View Profile from database"></btn>
                                    <btn @click.native="sois(user.id)"
                                         icon="fa fa-download"
                                         title="View Downloadable Profile"></btn>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                    <btn @click.native="startLink(user)"
                                         icon="fa fa-compress"
                                         title="Enable Link Mode"></btn>
                                </TheDropDownButton>
                            </td>
                            <td v-else-if="$store.getters.VIEWER">
                                <TheDropDownButton>
                                    <btn @click.native="soidb(user.id)"
                                         icon="fa fa-file"
                                         title="View Profile from database"></btn>
                                    <btn @click.native="sois(user.id)"
                                         icon="fa fa-download"
                                         title="View Downloadable Profile"></btn>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                </TheDropDownButton>
                            </td>
                            <td v-else>
                                <TheDropDownButton>
                                    <btn v-if="mydata"
                                         @click.native="editPerson(user.pid)"
                                         icon="fa fa-pencil-alt"
                                         title="Edit"></btn>
                                    <btn @click.native="attachSOI(user.id)"
                                         icon="fa fa-upload"
                                         title="Profile/SOI Upload"></btn>
                                    <btn @click.native="soidb(user.id)"
                                         icon="fa fa-file"
                                         title="View Profile from database"></btn>
                                    <btn @click.native="sois(user.id)"
                                         icon="fa fa-download"
                                         title="View Downloadable Profile"></btn>
                                    <btn @click.native="More(user)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                    <btn
                                         @click.native="startLink(user)"
                                         icon="fa fa-compress"
                                         title="Enable Link Mode"></btn>
                                </TheDropDownButton>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>

                <div v-show="totalitems == 0" class="alert alert-warning">
                    <p>Found no result try again</p>
                </div>
            </div>
        </div>

        <b-pagination v-model="pagingInfo.page"
                      v-on:input="fetchData()"
                      :total-rows="totalitems"
                      :per-page="pagingInfo.itemsPerPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"></b-pagination>
        <!-- Modal For Uploaded SOI -->
        <div>
            <b-modal id="soilist1" title="Uploaded SOI" scrollable hide-footer>
                <TheSoiProfile v-bind:id="soiId" />
            </b-modal>
        </div>
        <!-- Modal For SOI from DB -->
        <div>
            <b-modal id="soifromdb"
                     title="FullText SOI"
                     scrollable
                     hide-footer
                     size="xl">
                <span v-html="soifromdb"></span>
            </b-modal>
        </div>

        <b-modal id="LinkPopUP" title="Link Builder" scrollable hide-footer>
            <LinkPopUp />
        </b-modal>

        <b-modal id="EditPopUP"
                 title="Edit Person"
                 size="lg"
                 scrollable
                 hide-footer>
            <PersonEdit v-bind:id="personId" v-on:done-edit-person="doneEdit()" />
        </b-modal>

        <b-modal id="attachsoi"
                 title="Profile/SOI Upload"
                 scrollable
                 hide-footer
                 size="md">
            <attachSOI v-bind:id="personIdAttach"
                       v-bind:url="urlAttach"
                       v-on:done-edit-att="doneEditAtt()" />
        </b-modal>
        <b-modal id="linkpopup" size="xl" scrollable hide-footer>
            <LinkComponentPop v-bind:id="linkid"
                              v-bind:linkdescription="linkdescription" />
        </b-modal>
        <b-modal id="mergerecord"
                 size="md"
                 hide-footer
                 ref="merger"
                 no-close-on-esc="true"
                 no-close-on-backdrop="true"
                 hide-header-close="true">
            <MergePopUp v-bind:obj1ID="obj1Id"
                        v-bind:obj2ID="obj2Id"
                        v-bind:obj1Desc="obj1description"
                        v-bind:obj2Desc="obj2description"
                        v-bind:objType="objType"
                        v-on:done="done()"
                        v-on:cancel="cancel()" />
        </b-modal>
        <b-modal id="loglistprofile" size="xl" title="Download Logs" scrollable hide-footer>
                <ProfileLogs v-bind:id="logid" v-bind:url="urlLog" />
        </b-modal>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        RecordURL,
        notifyHelper,
        setObject2Link,
        EncodeURL,
        RequestLink
    } from "../helper";
    import LinkPopUp from "./master/Linking";
    import PersonEdit from "./edit/Person";
    import btn from "./buttons/iconButton";
    import attachSOI from "./master/editAttachment";
    import TheSoiProfile from "./master/soiProfile";
    import LinkComponentPop from "./link/linkcomponent";
    import MergePopUp from "./master/recordMerge";
    import instance from "../helper/http";
    import ProfileLogs from "./master/downloadLogs.vue";
    export default {
        data() {
            return {
                soifromdb: "",
                persons: [],
                pagingInfo: {
                    page: 1,
                    search: "",
                    mname: "",
                    lname: "",
                    sortBy: "DateCreated",
                    mydata: 0,
                },
                totalitems: null,
                soi: [],
                obj2: "",
                obj2t: "",
                personId: "",
                mydata: false,
                personIdAttach: "",
                urlAttach: "attachSOI",
                soiId: "",
                linkid: "",
                linkdescription: "",
                obj1Id: "",
                obj2Id: "",
                objType : "",
                obj1description: "",
                obj2description: "",
                hasfirst: false,
                logid : "",
                urlLog: "getprofiledownloadlogs"
                
            };
        },
        components: {
            LinkPopUp,
            PersonEdit,
            btn,
            attachSOI,
            TheSoiProfile,
            LinkComponentPop,
            MergePopUp,
            ProfileLogs
            //TheDropDownButton,
        },
        methods: {
            async requestlinkdownload(id) {
                await RequestLink(id);
            },
            clearControls() {
                this.pagingInfo.search = "";
                this.pagingInfo.mname = "";
                this.pagingInfo.lname = "";
                this.pagingInfo.mydata = 0;
            },
            fetchData() {
                if (this.pagingInfo.mydata == "0") this.mydata = false;
                else this.mydata = true;
                instance
                    .get(RecordURL + "getlist", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.persons = response.data.data;
                        this.totalitems = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                        this.mydata = false;
                        this.persons = [];
                        this.totalitems = 0;
                    });
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            More: function (data) {
                var additional1 =
                    (data.firstName ? data.firstName : "") +
                    " " +
                    (data.middleName ? data.middleName : "") +
                    " " +
                    (data.lastName ? data.lastName : "") +
                    " " +
                    (data.alias ? data.alias : "");
                additional1 = additional1.replace(/\//g, "-");
                this.linkid = data.id;
                this.linkdescription = additional1;
                this.$bvModal.show("linkpopup");
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            addtoMerge(data) {
                var additional =
                    (data.firstName ? data.firstName : "") +
                    " " +
                    (data.middleName ? data.middleName : "") +
                    " " +
                    (data.lastName ? data.lastName : "") +
                    " " +
                    (data.alias ? data.alias : "");
                additional = additional.replace(/\//g, "-");
                if (this.hasfirst) {
                    if (this.obj1Id == data.id)
                    {
                        notifyHelper("info", "Cannot merge the same person");
                    }
                    else
                    {
                        this.obj2description = additional;
                        this.obj2Id = data.id;
                        this.objType = "PN"
                        //open the popup
                        this.$bvModal.show("mergerecord");
                    }
                    
                } else {
                    this.obj1description = additional;
                    this.obj1Id = data.id;
                    this.hasfirst = true;
                    notifyHelper(
                        "success",
                        "Add to merging of record, please choose another record to merge"
                    );
                }
            },
            soidb: function (id) {
                instance
                    .get(RecordURL + "soidb?id=" + id + "&type=PN", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.withsoi) {
                            this.soifromdb = response.data.data;
                            this.$bvModal.show("soifromdb");
                        } else {
                            notifyHelper("warn", "SOI from database not found");
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            sois: function (id) {
                this.soiId = id;
                this.showModal();
            },
            setLink: function (id) {
                setObject2Link(id, "PN");
                this.$bvModal.show("LinkPopUP");
            },
            startLink: function (doc) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to enable link mode?.", {
                        title: "Enable Link Mode?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            var additional =
                                "FirstName: " +
                                (doc.firstName === null ? " " : doc.firstName) +
                                " MiddleName: " +
                                (doc.middleName === null ? " " : doc.middleName) +
                                " LastName: " +
                                (doc.lastName === null ? " " : doc.lastName) +
                                " Alias: " +
                                (doc.alias === null ? " " : doc.alias);
                            this.$store.commit("enablelinkMode", {
                                id: doc.id,
                                type: "PN",
                                description: additional,
                            });
                        }
                    });
                //.catch((err) => {});

                // if (confirm("Activate link mode?")) {

                // }
            },
            showModal: function () {
                this.$bvModal.show("soilist1");
            },
            editPerson: function (id) {
                this.personId = id;
                //modal
                this.$bvModal.show("EditPopUP");
            },
            doneEdit() {
                this.$bvModal.hide("EditPopUP");
            },
            cancel() {
                this.$bvModal.hide("mergerecord");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
            },
            done() {
                this.$bvModal.hide("mergerecord");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
                this.fetchData();
            },
            deletePerson: function (id,pid, index) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to delete?.", {
                        title: "Delete?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            instance
                                .get(RecordURL + "deletePerson?personID=" + id + "&pID=" + pid, {
                                    headers: authHeader(),
                                })
                                .then((response) => {
                                    if (response.data.error) {
                                        notifyHelper("error", response.data.message);
                                    } else {
                                        notifyHelper("success", response.data.message);
                                        this.persons.splice(index, 1)
                                    }
                                })
                                .catch(function (error) {
                                    responseCheck(error.response.status);
                                });
                        }
                    });
            },
            attachSOI: function (doc) {
                this.personIdAttach = doc;
                //modal
                this.$bvModal.show("attachsoi");
            },
            doneEditAtt() {
                this.$bvModal.hide("attachsoi");
            },
            deleteSOI: function (iD, fileName) {
                if (confirm("are you sure you want to delete?")) {
                    instance
                        .get(EncodeURL + "deleteSOI?iD=" + iD + "&fileName=" + fileName, {
                            headers: authHeader(),
                        })
                        .then((response) => {
                            if (response.data.error) {
                                notifyHelper("error", response.data.message);
                            } else {
                                notifyHelper("success", response.data.message);
                            }
                        })
                        .catch(function (error) {
                            responseCheck(error.response.status);
                        });
                }
            },
            viewLogs(id){
                this.logid = id;
                this.$bvModal.show("loglistprofile");
            }
        },
    };
</script>